export default {
      id: "ic_success_page_success-usage",
      viewBox: "0 0 32 32",
      url: "/" + "images/icons.3.109.2.svg#ic_success_page_success-usage",
      toString: function () {
        return this.url;
      }
    }